module.exports = __webpack_public_path__ + "media/audios/kid/lesson_3/audio5-f97a80932f6ca4fb92b49b7d195e98b2.m4a";